module.exports = __webpack_public_path__ + "img/mobile-right-arrow-unselected.91050c24.svg";